import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { fetchValoresAtributo, fetchAgrupamientos, fetchAtributosPorCategoriaAgrupamiento, setEstructuraAtributosValores, fetchEstructuraAtributosValores, fetchAtributosCategoria, limpiarEstructuraAtributosValores, limpiarAgrupamientos, limpiarProductoValores } from '../../../../actions/publicacionesActions';
import { customStyle, customStyleFilter } from '../../../../template/CustomStyle';
import { fetchPublicacionPorSkuMarket } from '../../../../actions/publicacionesActions';
import { toast } from '../../../../utilities/appToast';
import PropTypes from 'prop-types';

// Mismo look de .filter-card pero con lugar para el ícono de lupa a la izquierda
const buscadorAtributoStyle = {
    ...customStyleFilter,
    control: (base, state) => ({
        ...customStyleFilter.control(base, state),
        paddingLeft: 22,
    }),
};

class PublicacionesAtributos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // idAtributo -> idValor seleccionado
            attributeValuePublication: {},

            // idAtributo -> [{ value, label }]
            optionsByAtributo: {},

            // idAtributo -> indica si se están consultando sus valores
            loadingValoresByAtributo: {},

            // último atributo para el que buscamos valores (para mapear listValores)
            lastAtributoSearchId: null,

            // atributos extra agregados manualmente por agrupamiento
            // { [idAgrupacion]: [ { id, nombre, ... } ] }
            extraAtributosPorGrupo: {},

            // agrupamiento seleccionado en el combo superior
            // puede ser un id numérico o 'ALL'
            selectedAgrupamientoId: null,

            // atributo extra seleccionado en el combo (pero aún no agregado)
            selectedAtributoExtraId: null,

            // texto que se escribe en el combo de atributo_extra (para filtrar en front)
            atributoExtraSearchText: '',

            // atributos eliminados (no se muestran en los grupos, pero sí pueden re-aparecer en el combo extra)
            // { [idAtributo]: true }
            atributosEliminados: {},

            skuAReplicar: '',
            replicandoSku: false,
            skuReplicaEnCurso: null,

            cambiosEnListaEstructura: false
        };
    }

    componentDidMount() {

        this.props.setEstructuraAtributosValores({
            codProducto: String(""),
            idValor: []
        }, false);
        this.props.limpiarEstructuraAtributosValores();
        this.props.limpiarAgrupamientos();
        this.props.limpiarProductoValores();

        if (this.props.isEditing) {
            const idCategoria = this.props.publicacion?.categoria;
            const skuMarket = this.props.publicacion.skuMarket;

            if (idCategoria) {
                this.props.fetchAgrupamientos(idCategoria);
                this.props.fetchAtributosCategoria(idCategoria);
                if (!skuMarket) {
                    this.props.fetchEstructuraAtributosValores({ idCategoria: idCategoria });
                }
            }
            if (skuMarket) {
                this.props.fetchEstructuraAtributosValores({ codProducto: this.props.publicacion.skuMarket });
            }

        }

    }

    componentDidUpdate(prevProps) {

        // Si cambia la estructura (valores existentes), recalculamos iniciales
        if (prevProps.listaEstructura !== this.props.listaEstructura) {
            if (this.state.replicandoSku) {
                // Cambio de estructura provocado por replicar
                this.reemplazarTodoDesdeListaEstructuraReplicada();
            } else {
                // Cambio normal
                this.cargarValoresExistentesDesdeListaEstructura(this.state.cambiosEnListaEstructura);
            }
        }

        // Si cambian los valores traídos por la búsqueda, actualizamos opciones
        if (prevProps.listValores !== this.props.listValores) {
            this.actualizarOpcionesDesdeListValores();
        }

        const pub = this.props.publicacion;

        // Si estoy en la misma Publicacion pero cambio la Categoria, traigo la estructura de la Categoria
        if (pub?.idPublicacion === prevProps.publicacion?.idPublicacion && pub.categoria !== prevProps.publicacion?.categoria && pub.categoria !== 0) {
            this.setState({ cambiosEnListaEstructura: true });
            this.props.fetchAgrupamientos(pub.categoria);
            this.props.fetchAtributosCategoria(pub.categoria);
            this.props.fetchEstructuraAtributosValores({ idCategoria: pub.categoria });
        }
    }

    /**
     * Inicializa:
     *  - attributeValuePublication[atributoId] = idValor
     *  - optionsByAtributo[atributoId] = [{ value, label }] con el valor guardado
     */
    cargarValoresExistentesDesdeListaEstructura = (huboCambios) => {
        const rawListaEstructura = this.props.listaEstructura;

        if (!rawListaEstructura) return;

        const listaEstructura = Array.isArray(rawListaEstructura)
            ? rawListaEstructura
            : rawListaEstructura.listaEstructura;

        if (!listaEstructura || !Array.isArray(listaEstructura)) return;

        const initialValues = {};
        const initialOptionsByAtributo = {};

        listaEstructura.forEach(grupo => {
            if (!grupo.atributosValores) return;

            grupo.atributosValores.forEach(item => {
                if (!item.atributo || !item.valor) return;

                const atributoId = item.atributo.id;
                const valorId = item.valor.id;
                const valorNombre = (item.valor.nombre || '').trim();

                initialValues[atributoId] = valorId;

                initialOptionsByAtributo[atributoId] = [{
                    value: valorId,
                    label: valorNombre
                }];
            });
        });

        this.setState(prev => ({
            attributeValuePublication: initialValues,
            optionsByAtributo: {
                ...prev.optionsByAtributo,
                ...initialOptionsByAtributo
            }
        }), () => {
            this.dispatchEstructuraAtributosValores(huboCambios);
        });
    };

    /**
     * Usa this.props.listValores (resultado de fetchValoresAtributo)
     * y lo asigna como options del atributo lastAtributoSearchId.
     */
    actualizarOpcionesDesdeListValores = () => {
        const { lastAtributoSearchId } = this.state;
        if (!lastAtributoSearchId) return;

        const rawListValores = this.props.listValores;
        const listValores = Array.isArray(rawListValores)
            ? rawListValores
            : rawListValores?.listValores;

        if (!listValores || !Array.isArray(listValores)) return;

        const nuevasOpciones = listValores.map(v => ({
            value: v.id,
            label: (v.nombre || '').trim()
        }));

        this.setState(prev => ({
            optionsByAtributo: {
                ...prev.optionsByAtributo,
                [lastAtributoSearchId]: nuevasOpciones
            }
        }));
    };

    handleChange = (atributoId, selectedOption) => {
        this.setState(prev => ({
            attributeValuePublication: {
                ...prev.attributeValuePublication,
                [atributoId]: selectedOption ? selectedOption.value : null
            }
        }), this.dispatchEstructuraAtributosValores);
    };


    /**
     * Tipeo dentro del select de VALORES -> dispara búsqueda remota de valores.
     */
    cargarValoresAtributo = async (atributoId, descripcion) => {
        if (!this.props.fetchValoresAtributo) return;

        this.setState(prev => ({
            lastAtributoSearchId: atributoId,
            loadingValoresByAtributo: {
                ...prev.loadingValoresByAtributo,
                [atributoId]: true
            }
        }));

        try {
            await this.props.fetchValoresAtributo(atributoId, descripcion);
        } catch {
        } finally {
            this.setState(prev => ({
                loadingValoresByAtributo: {
                    ...prev.loadingValoresByAtributo,
                    [atributoId]: false
                }
            }));
        }
    };

    handleInputChange = (atributoId, inputValue, actionMeta) => {
        if (actionMeta.action === 'input-change') {
            this.cargarValoresAtributo(atributoId, inputValue);
        }

        return inputValue;
    };

    handleMenuOpen = (atributoId) => {
        this.cargarValoresAtributo(atributoId, '');
    };

    /**
     * Construye grupos base a partir de listaEstructura
     */
    buildGruposBase = (listaAtributos, listaEstructura) => {
        const grupos = [];
        const gruposMap = {};

        const mapaAtributosPorId = {};
        listaAtributos.forEach(a => {
            mapaAtributosPorId[a.id] = a;
        });

        if (listaEstructura && Array.isArray(listaEstructura)) {
            listaEstructura.forEach(grupoEstructura => {
                const idAgrupacion = grupoEstructura.idAgrupacion;
                const nombreAgrupacion = grupoEstructura.agrupacion;

                if (!gruposMap[idAgrupacion]) {
                    gruposMap[idAgrupacion] = {
                        idAgrupacion,
                        nombreAgrupacion,
                        atributos: []
                    };
                    grupos.push(gruposMap[idAgrupacion]);
                }

                if (!grupoEstructura.atributosValores) return;

                grupoEstructura.atributosValores.forEach(item => {
                    if (!item.atributo) return;

                    const atributoId = item.atributo.id;

                    let atributo = mapaAtributosPorId[atributoId];

                    // Si no viene en listaAtributos, lo armamos con los datos de la estructura
                    if (!atributo) {
                        atributo = {
                            id: atributoId,
                            nombre: item.atributo.nombre,
                            idAgrupamiento: idAgrupacion
                        };
                    }

                    // Evitar duplicados en el mismo grupo
                    if (!gruposMap[idAgrupacion].atributos.some(a => a.id === atributo.id)) {
                        gruposMap[idAgrupacion].atributos.push(atributo);
                    }
                });
            });
        }

        return grupos;
    };

    /**
     * IDs de atributos ya mostrados en el formulario (base + extras, sin los eliminados).
     * Se envían como NoIncluir para que la búsqueda de nuevos atributos no los vuelva a ofrecer.
     */
    getAtributosMostradosIds = () => {
        const rawListaAtributos = this.props.listaAtributos;
        const listaAtributos = Array.isArray(rawListaAtributos)
            ? rawListaAtributos
            : rawListaAtributos?.listAtributos;

        if (!listaAtributos || !Array.isArray(listaAtributos)) return [];

        const rawListaEstructura = this.props.listaEstructura;
        const listaEstructura = Array.isArray(rawListaEstructura)
            ? rawListaEstructura
            : rawListaEstructura?.listaEstructura;

        const { atributosEliminados, extraAtributosPorGrupo } = this.state;
        const gruposBase = this.buildGruposBase(listaAtributos, listaEstructura);

        const ids = new Set();
        gruposBase.forEach(g => {
            g.atributos.forEach(a => {
                if (!atributosEliminados[a.id]) ids.add(a.id);
            });
        });

        Object.values(extraAtributosPorGrupo).forEach(attrs => {
            (attrs || []).forEach(a => {
                if (!atributosEliminados[a.id]) ids.add(a.id);
            });
        });

        return Array.from(ids);
    };

    /**
     * Handler para selección de agrupamiento en el combo superior.
     */
    handleAgrupamientoChange = (selectedOption) => {
        const selectedAgrupamientoId = selectedOption ? selectedOption.value : null;

        this.setState({
            selectedAgrupamientoId,
            selectedAtributoExtraId: null,
            atributoExtraSearchText: ''
        });
    };

    /**
     * Tipeo en el combo de atributo_extra
     */
    handleAtributoExtraInputChange = (inputValue, actionMeta) => {
        if (actionMeta.action !== 'input-change') {
            return inputValue;
        }

        this.setState({ atributoExtraSearchText: inputValue });

        // Opcional: seguir llamando a la API
        //const idSubFamilia =
        //    this.props.idSubFamilia ||
        //    this.props.idCategoria ||
        //    this.props.idCategoriaSeleccionada;

        const idSubFamilia = this.props.publicacion?.categoria;

        if (idSubFamilia && this.props.fetchAtributosPorCategoriaAgrupamiento) {
            const { selectedAgrupamientoId } = this.state;
            const idAgrupacionParam =
                selectedAgrupamientoId && selectedAgrupamientoId !== 'ALL'
                    ? selectedAgrupamientoId
                    : null;

            this.props.fetchAtributosPorCategoriaAgrupamiento(
                idSubFamilia,
                idAgrupacionParam,
                inputValue,
                this.getAtributosMostradosIds()
            );
        }

        return inputValue;
    };

    handleAtributoExtraSelect = (selectedOption) => {
        this.setState({
            selectedAtributoExtraId: selectedOption ? selectedOption.value : null
        });
    };

    /**
     * Botón "Agregar" — busca primero en la lista filtrada por agrupamiento (resultado de la búsqueda)
     * y usa listaAtributos como fallback, para poder ubicar el atributo en su idAgrupamiento.
     */
    handleAgregarAtributoExtraClick = () => {
        const { selectedAtributoExtraId } = this.state;
        if (!selectedAtributoExtraId) return;

        const rawListaAtributos = this.props.listaAtributos;
        const listaAtributos = Array.isArray(rawListaAtributos)
            ? rawListaAtributos
            : rawListaAtributos?.listAtributos;

        const rawListaAtributosAgr = this.props.listAtributosAgrupamiento;
        const listaAtributosAgr = Array.isArray(rawListaAtributosAgr)
            ? rawListaAtributosAgr
            : rawListaAtributosAgr?.listAtributosAgrupamiento || rawListaAtributosAgr?.listAtributos;

        const atributo =
            (listaAtributosAgr || []).find(a => a.id === selectedAtributoExtraId) ||
            (listaAtributos || []).find(a => a.id === selectedAtributoExtraId);

        if (!atributo) return;

        const grupoId = atributo.idAgrupamiento;
        if (grupoId == null) return;

        this.setState(prev => {
            const current = prev.extraAtributosPorGrupo[grupoId] || [];

            // Siempre limpiamos el flag de eliminado para este atributo
            const newAtributosEliminados = { ...prev.atributosEliminados };
            delete newAtributosEliminados[atributo.id];

            const yaEstaEnExtras = current.some(a => a.id === atributo.id);

            // 🔁 Caso 1: el atributo ya estaba en extraAtributosPorGrupo
            // (por ejemplo, se agregó manualmente, se eliminó y ahora se quiere "revivir")
            // En este caso NO lo volvemos a agregar porque ya está en el array,
            // solo quitamos el flag de eliminado para que vuelva a mostrarse.
            if (yaEstaEnExtras) {
                return {
                    ...prev,
                    selectedAtributoExtraId: null,
                    atributoExtraSearchText: '',
                    atributosEliminados: newAtributosEliminados
                };
            }

            // ➕ Caso 2: no estaba en extras (puede venir de la base o ser nuevo)
            // Lo agregamos al grupo correspondiente y, de paso, nos aseguramos
            // de que no esté marcado como eliminado.
            return {
                ...prev,
                extraAtributosPorGrupo: {
                    ...prev.extraAtributosPorGrupo,
                    [grupoId]: [...current, atributo]
                },
                selectedAtributoExtraId: null,
                atributoExtraSearchText: '',
                atributosEliminados: newAtributosEliminados
            };
        });
    };

    /**
     * Eliminar atributo (tachito)
     */
    handleEliminarAtributo = (atributoId) => {
        this.setState(prev => {
            const newAttributeValuePublication = { ...prev.attributeValuePublication };
            delete newAttributeValuePublication[atributoId];

            return {
                ...prev,
                attributeValuePublication: newAttributeValuePublication,
                atributosEliminados: {
                    ...prev.atributosEliminados,
                    [atributoId]: true
                }
            };
        }, this.dispatchEstructuraAtributosValores);
    };


    dispatchEstructuraAtributosValores = (huboCambios = true) => {
        const codProducto = this.props.codProducto || this.props.publicacion?.skuMarket;

        const ids = Object.values(this.state.attributeValuePublication || {})
            .filter(v => v !== null && v !== undefined)
            .map(Number)
            .filter(v => !Number.isNaN(v));

        const idValor = Array.from(new Set(ids));

        if (this.props.setEstructuraAtributosValores) {
            this.props.setEstructuraAtributosValores({
                codProducto: String(codProducto),
                idValor
            }, huboCambios);
        }
    };


    handleSkuAReplicarChange = (e) => {
        this.setState({ skuAReplicar: e.target.value });
    };


    validarYReplicarSku = async () => {
        const cleanSku = (this.state.skuAReplicar || '').trim();
        if (!cleanSku) {
            toast.error("Debe ingresar un SKU para replicar.");
            return;
        }

        // Datos del producto actual
        const pubActual = this.props.publicacion;
        const idSellerActual = pubActual?.idSeller;
        const categoriaActual = pubActual?.categoria;

        if (!idSellerActual || !categoriaActual) {
            toast.error("La publicación actual aún no está cargada");
            return;
        }

        try {
            const resp = await fetchPublicacionPorSkuMarket(cleanSku);

            const item = resp?.elementos?.[0];
            if (!item) {
                toast.error("No se encontró una publicación para el SKU ingresado.");
                return;
            }

            // Validaciones
            if (String(item.idSeller) !== String(idSellerActual)) {
                toast.error("El SKU a replicar no pertenece al mismo Seller.");
                return;
            }

            if (String(item.categoria?.codigo) !== String(categoriaActual)) {
                toast.error("El SKU a replicar no pertenece a la misma categoría.");
                return;
            }

            // ✅ OK → replicar
            this.duplicarAtributos(cleanSku);

        } catch {
            toast.error("Error al validar el SKU a replicar.");
        }
    };


    duplicarAtributos = (sku) => {
        const cleanSku = (sku || '').trim();

        if (!cleanSku) {
            alert('Debe ingresar un SKU para replicar.');
            return;
        }

        if (!this.props.fetchEstructuraAtributosValores) return;

        // Marcamos que estamos replicando: cuando cambie listaEstructura -> reemplazo total
        this.setState({
            replicandoSku: true,
            skuReplicaEnCurso: cleanSku
        }, () => {
            this.props.fetchEstructuraAtributosValores({ codProducto: cleanSku });
        });
    };


    reemplazarTodoDesdeListaEstructuraReplicada = () => {
        const rawListaEstructura = this.props.listaEstructura;
        if (!rawListaEstructura) return;

        const listaEstructura = Array.isArray(rawListaEstructura)
            ? rawListaEstructura
            : rawListaEstructura.listaEstructura;

        if (!listaEstructura || !Array.isArray(listaEstructura)) return;

        const initialValues = {};
        const initialOptionsByAtributo = {};

        listaEstructura.forEach(grupo => {
            if (!grupo.atributosValores) return;

            grupo.atributosValores.forEach(item => {
                if (!item.atributo || !item.valor) return;

                const atributoId = item.atributo.id;
                const valorId = item.valor.id;
                const valorNombre = (item.valor.nombre || '').trim();

                initialValues[atributoId] = valorId;
                initialOptionsByAtributo[atributoId] = [{ value: valorId, label: valorNombre }];
            });
        });

        // Reemplazo total (pantalla = producto replicado)
        this.setState(prevState => ({
            attributeValuePublication: initialValues,
            optionsByAtributo: initialOptionsByAtributo,
            lastAtributoSearchId: null,

            // limpiar extras y eliminados para que quede 100% como el replicado
            extraAtributosPorGrupo: {},
            atributosEliminados: {},

            // limpiar selección de “agregar atributo”
            // mantener agrupamiento elegido
            selectedAgrupamientoId: prevState.selectedAgrupamientoId,

            // limpio el atributo extra seleccionado y el texto para evitar estados raros
            selectedAtributoExtraId: null,
            atributoExtraSearchText: '',

            // fin replicación
            replicandoSku: false,
            skuReplicaEnCurso: null
        }), () => {
            // Importante: esto deja listo productoValores para el producto actual (codProducto actual)
            this.dispatchEstructuraAtributosValores();
        });
    };


    renderSinCategoriaMessage = () => (
        <div className="p-20">
            <div className="alert alert-info">
                Seleccioná una categoría en Datos Básicos para cargar las características.
            </div>
        </div>
    );

    render() {
        // La categoría real de la publicación manda por sobre listaAtributos, que puede quedar
        // en el store de una publicación anterior aunque esta no tenga categoría seleccionada.
        const categoriaSeleccionada = this.props.publicacion?.categoria;
        if (!categoriaSeleccionada) {
            return this.renderSinCategoriaMessage();
        }

        const rawListaAtributos = this.props.listaAtributos;
        const listaAtributos = Array.isArray(rawListaAtributos)
            ? rawListaAtributos
            : rawListaAtributos?.listAtributos;

        if (!listaAtributos || !Array.isArray(listaAtributos)) {
            return this.renderSinCategoriaMessage();
        }

        const rawListaEstructura = this.props.listaEstructura;
        const listaEstructura = Array.isArray(rawListaEstructura)
            ? rawListaEstructura
            : rawListaEstructura?.listaEstructura;

        const { atributosEliminados } = this.state;

        // Grupos base (DB)
        const gruposBase = this.buildGruposBase(listaAtributos, listaEstructura);

        // Agrupamientos
        const rawListAgrupamiento = this.props.listAgrupamiento;
        const listAgrupamiento = Array.isArray(rawListAgrupamiento)
            ? rawListAgrupamiento
            : rawListAgrupamiento?.listAgrupamiento;

        const agrupamientosMap = {};
        const opcionesAgrupamiento = [];

        if (listAgrupamiento && listAgrupamiento.length > 0) {
            opcionesAgrupamiento.push({
                value: 'ALL',
                label: 'Todos los agrupamientos'
            });

            listAgrupamiento.forEach(g => {
                const id =
                    g.idAgrupamiento ??
                    g.idAgrupacion ??
                    g.id;
                const label =
                    g.agrupacion ??
                    g.nombre ??
                    g.descripcion ??
                    `Agrupamiento ${id}`;

                agrupamientosMap[id] = label;

                opcionesAgrupamiento.push({ value: id, label });
            });
        }

        const selectedAgrupamientoOption =
            opcionesAgrupamiento.find(o => o.value === this.state.selectedAgrupamientoId) || null;

        // Agrego extras + filtro eliminados
        const gruposMap = {};
        gruposBase.forEach(g => {
            gruposMap[g.idAgrupacion] = {
                idAgrupacion: g.idAgrupacion,
                nombreAgrupacion: g.nombreAgrupacion,
                atributos: g.atributos.filter(a => !atributosEliminados[a.id])
            };
        });

        Object.entries(this.state.extraAtributosPorGrupo).forEach(([key, attrs]) => {
            const idAgr = Number.isNaN(key) ? key : Number(key);
            if (!attrs || attrs.length === 0) return;

            if (!gruposMap[idAgr]) {
                gruposMap[idAgr] = {
                    idAgrupacion: idAgr,
                    nombreAgrupacion: agrupamientosMap[idAgr] || `Agrupamiento ${idAgr}`,
                    atributos: []
                };
            }

            attrs.forEach(a => {
                if (!atributosEliminados[a.id] &&
                    !gruposMap[idAgr].atributos.some(x => x.id === a.id)) {
                    gruposMap[idAgr].atributos.push(a);
                }
            });
        });

        const gruposFinales = Object.values(gruposMap).filter(
            g => g.atributos && g.atributos.length > 0
        );

        // ----------- SELECT DE ATRIBUTOS EXTRA (FIX) -----------
        const rawListaAtributosAgr = this.props.listAtributosAgrupamiento;
        const listaAtributosAgr = Array.isArray(rawListaAtributosAgr)
            ? rawListaAtributosAgr
            : rawListaAtributosAgr?.listAtributosAgrupamiento ||
            rawListaAtributosAgr?.listAtributos;

        // Fuente principal: listAtributosAgrupamiento; fallback: listaAtributos
        let atributosSource = (listaAtributosAgr && listaAtributosAgr.length > 0)
            ? listaAtributosAgr
            : listaAtributos;

        const usedIds = new Set();
        gruposFinales.forEach(g => {
            g.atributos.forEach(a => usedIds.add(a.id));
        });

        const { selectedAgrupamientoId, atributoExtraSearchText } = this.state;
        const search = (atributoExtraSearchText || '').toLowerCase().trim();

        if (selectedAgrupamientoId && selectedAgrupamientoId !== 'ALL') {
            atributosSource = atributosSource.filter(
                a => String(a.idAgrupamiento) === String(selectedAgrupamientoId)
            );
        }

        if (search) {
            atributosSource = atributosSource.filter(
                a => (a.nombre || '').toLowerCase().includes(search)
            );
        }

        const atributosExtraDisponibles =
            (atributosSource || []).filter(a => !usedIds.has(a.id));

        const opcionesAtributosExtra = atributosExtraDisponibles.map(a => ({
            value: a.id,
            label: a.nombre
        }));

        const selectedAtributoExtraOption =
            opcionesAtributosExtra.find(o => o.value === this.state.selectedAtributoExtraId) || null;

        const botonAgregarDisabled =
            !this.state.selectedAtributoExtraId ||
            opcionesAtributosExtra.length === 0;

        return (
            <div className="p-20">

                {/* Toolbar de búsqueda/filtros, mismo estilo que el resto de los listados (filter-card) */}
                <div className="card card-body filter-card mb-4">
                    <div className="row form-material g-3 align-items-end">

                        <div className={opcionesAgrupamiento.length > 0 ? "col-12 col-md-5" : "col-12 col-md-7"}>
                            <label htmlFor="agregarAtributo" className="label-oscura">Buscar atributo</label>
                            <div className="position-relative">
                                <i
                                    className="fas fa-search position-absolute"
                                    style={{ left: 12, top: '50%', transform: 'translateY(-50%)', color: '#8d97ad', zIndex: 2, pointerEvents: 'none' }}
                                    aria-hidden="true"
                                ></i>
                                <Select
                                    id="agregarAtributo"
                                    name="atributo_extra"
                                    value={selectedAtributoExtraOption}
                                    onChange={this.handleAtributoExtraSelect}
                                    onInputChange={this.handleAtributoExtraInputChange}
                                    options={opcionesAtributosExtra}
                                    placeholder="Ej: Color, Modelo..."
                                    isClearable
                                    styles={buscadorAtributoStyle}
                                />
                            </div>
                        </div>

                        {opcionesAgrupamiento.length > 0 ? (
                            <div className="col-12 col-md-3">
                                <label htmlFor="selectAgrup" className="label-oscura">Filtrar por grupo de atributo</label>
                                <div className="d-flex gap-2">
                                    <div className="flex-grow-1">
                                        <Select
                                            id="selectAgrup"
                                            name="agrupamiento"
                                            value={selectedAgrupamientoOption}
                                            onChange={this.handleAgrupamientoChange}
                                            options={opcionesAgrupamiento}
                                            placeholder="Todos los grupos"
                                            isClearable
                                            styles={customStyleFilter}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary flex-shrink-0"
                                        disabled={botonAgregarDisabled}
                                        onClick={this.handleAgregarAtributoExtraClick}
                                    >
                                        + Agregar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="col-12 col-md-2">
                                <label className="label-oscura d-none d-md-block">&nbsp;</label>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary w-100"
                                    disabled={botonAgregarDisabled}
                                    onClick={this.handleAgregarAtributoExtraClick}
                                >
                                    + Agregar
                                </button>
                            </div>
                        )}

                        <div className={opcionesAgrupamiento.length > 0 ? "col-12 col-md-4" : "col-12 col-md-7"}>
                            <label htmlFor="replicSKU" className="label-oscura">Replicar de otro SKU</label>
                            <div className="d-flex gap-2">
                                <input
                                    id="replicSKU"
                                    type="text"
                                    className="form-control"
                                    value={this.state.skuAReplicar}
                                    onChange={this.handleSkuAReplicarChange}
                                    placeholder="Ingrese SKU..."
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-dark flex-shrink-0"
                                    onClick={this.validarYReplicarSku}
                                    disabled={!(this.state.skuAReplicar || '').trim()}
                                >
                                    <i className="fas fa-clone me-1" aria-hidden="true"></i>Replicar
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                {gruposFinales.map(grupo => (
                    <div key={grupo.idAgrupacion} className="mb-4 p-3 border rounded">
                        <h5 className="mb-3">{grupo.nombreAgrupacion}</h5>

                        {grupo.atributos.map(atributo => {
                            const atributoId = atributo.id;
                            const valorIdSeleccionado = this.state.attributeValuePublication[atributoId];
                            const opciones = this.state.optionsByAtributo[atributoId] || [];
                            const selectedOption = opciones.find(o => o.value === valorIdSeleccionado) || null;
                            const cargandoValores = this.state.loadingValoresByAtributo[atributoId] || false;

                            return (
                                <div className="row pb-2" key={atributoId}>
                                    <div className="col-sm-4 col-md-4 col-lg-4 pt-2">
                                        <label>{atributo.nombre}</label>
                                    </div>

                                    <div className="col-sm-7 col-md-7 col-lg-7">
                                        <Select
                                            name={`atributo_${atributoId}`}
                                            value={selectedOption}
                                            onChange={(option) => this.handleChange(atributoId, option)}
                                            onInputChange={(inputValue, actionMeta) =>
                                                this.handleInputChange(atributoId, inputValue, actionMeta)
                                            }
                                            onMenuOpen={() => this.handleMenuOpen(atributoId)}
                                            options={opciones}
                                            placeholder="Seleccione..."
                                            isLoading={cargandoValores}
                                            loadingMessage={() => 'Cargando...'}
                                            noOptionsMessage={() => 'No se encontraron opciones'}
                                            isClearable
                                            styles={customStyle}
                                        />
                                    </div>

                                    <div className="col-sm-1 col-md-1 col-lg-1 d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn btn-link text-danger p-0"
                                            onClick={() => this.handleEliminarAtributo(atributoId)}
                                            title="Eliminar atributo"
                                        >
                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        );
    }

}
PublicacionesAtributos.propTypes = {
    // Redux props
    isEditing: PropTypes.bool,
    publicacion: PropTypes.shape({
        categoria: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        skuMarket: PropTypes.string,
        idPublicacion: PropTypes.number,
        idSeller: PropTypes.number,
    }),
    listaEstructura: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        listaEstructura: PropTypes.array
    })]),
    listValores: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        listValores: PropTypes.array
    })]),
    listaAtributos: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        listAtributos: PropTypes.array
    })]),
    listAgrupamiento: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        listAgrupamiento: PropTypes.array
    })]),
    listAtributosAgrupamiento: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        listAtributosAgrupamiento: PropTypes.array,
        listAtributos: PropTypes.array, // fallback
    })]),
    codProducto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    setEstructuraAtributosValores: PropTypes.func,
    limpiarEstructuraAtributosValores: PropTypes.func,
    limpiarAgrupamientos: PropTypes.func,
    limpiarProductoValores: PropTypes.func,
    fetchAgrupamientos: PropTypes.func,
    fetchAtributosCategoria: PropTypes.func,
    fetchEstructuraAtributosValores: PropTypes.func,
    fetchAtributosPorCategoriaAgrupamiento: PropTypes.func,
    fetchValoresAtributo: PropTypes.func
}

const mapStateToProps = state => ({

    listValores: state.publicaciones.listValores,
    listaEstructura: state.publicaciones.listaEstructura,
    listaAtributos: state.publicaciones.listAtributos,
    listAgrupamiento: state.publicaciones.listAgrupamiento,
    listAtributosAgrupamiento: state.publicaciones.listAtributosAgrupamiento,

    publicacion: state.publicaciones.publicacion,
});

export default connect(mapStateToProps, { fetchValoresAtributo, fetchAgrupamientos, fetchAtributosPorCategoriaAgrupamiento, setEstructuraAtributosValores, fetchEstructuraAtributosValores, fetchAtributosCategoria, limpiarEstructuraAtributosValores, limpiarAgrupamientos, limpiarProductoValores })(PublicacionesAtributos);